<div class="section-title pop-report section-title--popreport" style="padding-top:33px;" title="Image contains a snapshot of the POP Report header">
  <h2>Pop Report</h2>
</div>
<br />
<div style="background-color: white">
  <div class="content content--compact" style="height: 0; min-height: 3vh; margin-top: -12px; padding-top: 70px">
    <h2 style="margin-top: -35px;">Start POP Lookup</h2>
    <p style="margin-top: -30px;">
      Enter the card set you are looking for in the box below. Load your set, then find your card.
    </p>
  </div>


  <div class="content content--compact res-capt" style="height:0;">
    <form [formGroup]="searchPopReportForm" style="margin:auto;">
      <div class="d-flex extra-margin">
        <div>
          <h4 style="padding-bottom:4px;">Card Set</h4>
          <input type="text" class="input" placeholder="Card Set" (keydown.enter)="getPopReportByCardSetEnter()" formControlName="popReportSearch" style="width:285px;">
          <div *ngIf="PopReportSubmitted && !searchPopReportForm.controls['popReportSearch'].valid" style="color:red;margin-top: 0px;">
            <p *ngIf="searchPopReportForm.controls['popReportSearch'].hasError('required')" class="text-danger">
              * Card Set is required
            </p>
            <p *ngIf="searchPopReportForm.controls['popReportSearch'].hasError('minlength')" class="text-danger">
              Minimum 8 characters
            </p>
          </div>
          <div style="margin-top: 15px;">
            <div>
              <!-- reCAPTCHA Enterprise Checkbox Container -->
              <div id="recaptcha-enterprise-container"></div>
              <p *ngIf="captchaError" style="color:red; margin-top: 5px;">
                * Please complete the reCAPTCHA challenge
              </p>
            </div>
            <!--<ngx-recaptcha2 #captchaElemPop [size]="size"
            [siteKey]="siteKey"
                            [hl]="lang" [theme]="theme" [type]="type">
            </ngx-recaptcha2>
            <p *ngIf="Captcha" style="color:red;">
                * Captcha is required
            </p>-->
          </div>
        </div>
        <div style="margin-top:30px;text-align:left;">
          <div class="submitBtn">
            <button class="submit-btn e-btn" (click)="getPopReportByCardSet()" id="submit-btn" style="padding-bottom:7px;padding-top:4px;cursor:pointer;">
              <span *ngIf="!isSearching">Search</span>
              <div *ngIf="isSearching" class="loader xs invert-color"></div>
            </button>
          </div>
        </div>
      </div>
    </form>

  </div>

  <div style="text-align:center;" *ngIf="PopLineheck==false">
    <div style="text-align:center;font-size:17px;font-weight:600;padding-top:105px;color: #785aff;">The POP is currently updating with today's transactions. Please try again later.</div>
  </div>

  <div class="centered-overlay" style="height:335px;" [class.active]="isSearching" *ngIf="isSearching">
    <div class="welcome">
      <div class="loader xl" style="background-size: 100px;width: 110px;height: 140px;"></div>
      <div style="text-align:center;font-size:17px;font-weight:600;">POP Loading...</div>
    </div>
  </div>
  <br />
  <div *ngIf="show" style="margin-top:90px;">
    <div class="custom-padding" *ngIf="AllPopulationReportSearch.length == 0">
      <div>
        <p style="text-align: center;font-size:17px;font-weight:600;padding-top:30px;">No Result Found.</p>
      </div>
    </div>
    <div class="custom-padding" *ngIf="AllPopulationReportSearch.length != 0">
      <ejs-grid #grid2 [dataSource]='AllPopulationReportSearch' [filterSettings]='filterOptions' [allowFiltering]='true' [sortSettings]='sortOptions' [allowSorting]='true' height='50%' gridLines='Both'>
        <e-columns>
          <e-column field='cardSet' headerText='Set Name' width='150' textAlign="left">
            <ng-template #template let-AllPopulationReportSearch>
              <a style="text-decoration-line: none;cursor: pointer;" (click)="click(AllPopulationReportSearch.cardSet,AllPopulationReportSearch.sport)">{{AllPopulationReportSearch.cardSet}}</a>
            </ng-template>
          </e-column>
          <e-column field='sport' headerText='Sport' [filter]='filter' width='60' textAlign="left"></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
  <br />


  <div class="content content--compact to-collectors" style="margin-bottom: 0px; padding-top: 50px">
    <h2>TO OUR COLLECTORS</h2>
    <p>
      With over {{ yearsInBusiness }} years of data included in the SGC Pop Report, inconsistencies may be present. If you find any inconsistencies/duplicates on the Pop Report, please email <a href="">support@gosgc.com</a>. We will do everything we can to have the reported data issues rectified. We've continued to make tremendous progress with data collection and organization, and we're looking forward to improving it even further for all collectors.
    </p>
  </div>
</div>

<style>
  @media screen and (max-width: 700px) {
    .extra-margin {
      margin-top: 40px;
    }
  }
</style>
